import React from 'react';
import PropTypes from 'prop-types';
import UpwardLogo from '../../../../components/Logo';

const fontSizeMapping = {
   small: {
      title: '12px',
      description: '10px',
   },
   medium: {
      title: '14px',
      description: '12px',
   },
   large: {
      title: '16px',
      description: '14px',
   },
};

const adUnitKeyList = Array.from({ length: 5 }, (v, i) => (Math.floor(Math.random() * 1000)));

const AdUnitItem = (props) => {
   return (
      <div
         className='cursor-pointer d-flex'
         style={{
            marginBottom: '9px',
            fontSize: `${ props.fontSize.description }`,
         }}
      >
         {
            props.includeLogo
            && (
               <div
                  className='d-flex align-self-center justify-content-center'
                  style={{
                     width: `${ props.logoSize }px`,
                     height: `${ props.logoSize }px`,
                     marginRight: '16px',
                  }}
               >
                  <UpwardLogo/>
               </div>
            )
         }
         <div>
            <div
               style={{
                  color: props.titleColor,
                  lineHeight: '1.4em',
                  fontSize: `${ props.fontSize.title }`,
                  textDecoration: 'underline',
                  fontWeight: '700',
               }}
            >
               Enter Your Ad Title Here - (Enter Your Custom Ad Title Here)
            </div>
            <div
               style={{
                  color: props.urlColor,
                  lineHeight: '1.4em',
                  fontWeight: '700',
               }}
            >
               www.advertiserurl.com/yourdisplayurl
            </div>
            <div
               style={{
                  color: props.copyColor,
                  lineHeight: '1.4em',
                  fontWeight: '400',
               }}
            >
               Enter your Ad Description here.  Enter your Ad Description here.  Enter your Ad...
            </div>
         </div>
      </div>
   );
};



const AdUnitVisualizer = (props) => {
   return (
      <div
         style={{
            padding: '5px',
            backgroundColor: props.backgroundColor,
            border: `${ props.borderWidth }px solid ${ props.borderColor }`,
            fontFamily: props.fontFamily,
         }}
      >
         {
            Array.from({ length: props.numAds }).map((v, i) => (
               <AdUnitItem
                  key={adUnitKeyList[i]}
                  {...props}
                  fontSize={fontSizeMapping[props.fontSize]}
               />
            ))
         }
      </div>
   );
};

AdUnitVisualizer.propTypes = {
   // Color
   backgroundColor: PropTypes.string.isRequired,
   titleColor: PropTypes.string.isRequired,
   urlColor: PropTypes.string.isRequired,
   copyColor: PropTypes.string.isRequired,
   borderColor: PropTypes.string.isRequired,
   // font
   fontFamily: PropTypes.string.isRequired,
   fontSize: PropTypes.string.isRequired,
   // border
   borderWidth: PropTypes.number.isRequired,
   // logo
   includeLogo: PropTypes.bool.isRequired,
   logoSize: PropTypes.number.isRequired,
   numAds: PropTypes.number.isRequired,
};

AdUnitVisualizer.defaultProps = {

};


export default AdUnitVisualizer;
